import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise';


import rootReducer from './reducers';

const composeEnhancers =
  /* eslint-disable-next-line no-undef */
  typeof window === 'object' && __DEVELOP__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

/* eslint-disable-next-line no-undef */
const middleware = [promiseMiddleware];

const enhancer = composeEnhancers(
  applyMiddleware(...middleware)
  // other store enhancers if any
);

const store = createStore(rootReducer, enhancer);

export default store;
